import Cookies from "js-cookie"
import { connect } from "react-redux"

import { toggleCountryModal } from "app-store-v2/app/actions"
import { getGlobalECookieData, IS_INT } from "helpers/application"
import getJewlrCountries from "site-data/jewlr/countries"
import getPortalCountries from "site-data/portal/countries"

export default function withGeo(WrappedComponent) {
  const WithGeo = (props) => <WrappedComponent {...props} />

  const mapStateToProps = (state) => {
    const geo = Cookies.get("geo")
    const site_country_for_analytics = sl.config.site_country_for_analytics
    const allCountries =
      sl.config.organization == "jewlr4"
        ? getJewlrCountries()
        : getPortalCountries()

    let currentCountryISO
    if (IS_INT()) {
      const globalEData = getGlobalECookieData()
      currentCountryISO = globalEData?.countryISO || site_country_for_analytics
    } else {
      currentCountryISO = site_country_for_analytics
    }

    const currentCountry = allCountries.find((c) => c.geo === currentCountryISO)

    return {
      currentCountry: currentCountry,
      geoCookie: geo || site_country_for_analytics,
      geoCookieDefault: geo,
      isMobile: state.browser.is.mobile,
      selectedGeoCookie: Cookies.get("selected_geo"),
      showCountryModal: !!state.localeHM.showCountryModal,
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      setSelectedGeo: (geo) => {
        Cookies.set("selected_geo", geo, { expires: 365, secure: true })
      },
      toggleCountryModal: (toggle) => {
        dispatch(toggleCountryModal(toggle))
      },
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithGeo)
}
